import { render, staticRenderFns } from "./DesignRirekisho001Edit.vue?vue&type=template&id=2d435ddc&scoped=true"
import script from "./DesignRirekisho001Edit.vue?vue&type=script&lang=js"
export * from "./DesignRirekisho001Edit.vue?vue&type=script&lang=js"
import style0 from "./DesignRirekisho001Edit.vue?vue&type=style&index=0&id=2d435ddc&prod&lang=scss&scoped=true"
import style1 from "./DesignRirekisho001Edit.vue?vue&type=style&index=1&id=2d435ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d435ddc",
  null
  
)

export default component.exports